import { render, staticRenderFns } from "./teacherManage.vue?vue&type=template&id=4e15bba6&scoped=true&"
import script from "./teacherManage.vue?vue&type=script&lang=js&"
export * from "./teacherManage.vue?vue&type=script&lang=js&"
import style0 from "./teacherManage.vue?vue&type=style&index=0&id=4e15bba6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e15bba6",
  null
  
)

export default component.exports